import { Component, OnDestroy } from '@angular/core';
import { catchError, EMPTY, exhaustMap, interval, Subscription } from 'rxjs';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-gauge-realtime-current-vs-peak-users',
  templateUrl: './gauge-realtime-current-vs-peak-users.component.html',
  styleUrl: './gauge-realtime-current-vs-peak-users.component.scss',
})
export class GaugeRealtimeCurrentVsPeakUsersComponent implements OnDestroy {
  subscriptions: Subscription[] = [];
  isLoading = true;

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.realTimeGaugeCurrentVsPeak$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('gaugeRealtimeCurrentVsPeak');
    });

    this.getChartData();

    this.subscriptions.push(
      interval(10000)
        .pipe(
          // Nächster Abruf erst, wenn der letzte zurück ist.
          exhaustMap(() =>
            this.analyticsService.getRealTimeGaugeCurrentVsPeak().pipe(catchError(() => EMPTY))
          )
        )
        .subscribe()
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  getChartData() {
    this.analyticsService.getRealTimeGaugeCurrentVsPeak().subscribe();
  }

  get currentValue() {
    return this.analyticsService.realTimeGaugeCurrentVsPeak$.value
      ?.current_active;
  }

  get maxValue() {
    const value =
      this.analyticsService.realTimeGaugeCurrentVsPeak$.value?.max_active;

    if (value < 10 || !value) {
      return 10;
    }

    // round up to the next multiple of 10
    if (value % 10 !== 0) {
      return Math.ceil(value / 10) * 10;
    }

    return value;
  }
}
